<template>
    <div class="menu_section filters_menu ">
      <span class="menu_overlay" @click="toggleFilterMenu"></span>
      <div class="filters_menu_cnt"> 
        <div @click="toggleFilterMenu" class="filter-btn">
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
        </div>
        <slot></slot> 
      </div>
    </div>
  </template>
 
 <script>
 export default {
   data() {
     return {
       isFilterMenuOpen: false,
     };
   },
   methods: {
     toggleFilterMenu() {
        // console.log('test')
    //    this.isFilterMenuOpen = !this.isFilterMenuOpen;
       if ( document.body.classList.contains("scroll-hidden")) {
         document.body.classList.remove('scroll-hidden');
       } else {
         document.body.classList.add('scroll-hidden');
       }
     },
     updateToggle(val){
        console.log('val', val)
        this.isFilterMenuOpen = val;
        document.body.classList.remove('scroll-hidden');
     },
   },
 };
 </script>